import React from 'react';
import Layout from '../components/layout/Layout';
import HeroSection from '../components/home/HeroSection';
import ServicesSection from '../components/home/ServicesSection';
import ProjectsSection from '../components/home/ProjectsSection';
import ClientsSection from '../components/home/ClientsSection';
import WorkProcessSection from '../components/home/WorkProcessSection';
import AboutSection from '../components/home/AboutSection';
import TestimonialSection from '../components/home/TestimonialSection';
import BlogSection from '../components/home/BlogSection';
import FAQSection from '../components/home/FAQSection';

const HomePage = () => {
  return (
    <Layout>
      <HeroSection />
      <ServicesSection />
      <ProjectsSection />
      <ClientsSection />
      <WorkProcessSection />
      <AboutSection />
      <TestimonialSection />
      <BlogSection />
      <FAQSection />
    </Layout>
  );
};

export default HomePage;
